module.exports = __webpack_public_path__ + "img/11-s.9e348225.png";